import { memo } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import LogoSection from 'pages/ModalOverViewPageHeaderV1/components/LogoSection';
import UserActions from 'pages/ModalOverViewPageHeaderV1/components/UserActions';
import { HEADER_CONFIG } from 'pages/ModalOverViewPageHeaderV1/constants';
import { UserModalNew } from 'pages/UserManagement/ProfileNewUIRevamp';

const HeaderV1 = () => {
  return (
    <Box>
      <Flex
        w='100%'
        h={HEADER_CONFIG.HEIGHT}
        minH={HEADER_CONFIG.HEIGHT}
        px={6}
        py={3}
        alignItems='center'
        justifyContent='space-between'
        bg={HEADER_CONFIG.BG_COLOR}
        boxShadow='sm'
      >
        <LogoSection globalHeader={true} />
        <UserActions globalHeader={true} />
      </Flex>
      <UserModalNew />
    </Box>
  );
};

export default memo(HeaderV1);
